import {useCallback, useState} from "react";

export function useFetchedResource<T, P = undefined>(get: (param: P) => Promise<T>) {
  const [resource, setResource] = useState<T | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState<boolean|null>(null);

  const fetchResource = useCallback(async (param: P, fetchSilently = false) => {
    const shouldModifyLoadingState = !fetchSilently || loading === null;
    if (shouldModifyLoadingState) {
      setLoading(true);
    }
    let fetchedResource = null
    try {
      fetchedResource = await get(param);
      setResource(fetchedResource);
    } catch (error) {
      // @ts-ignore
      setError(error);
    } finally {
      if (shouldModifyLoadingState) {
        setLoading(false);
      }
    }
    return fetchedResource
  }, [loading]);

  return { resource, error, loading: loading === null ? false : loading, reload: fetchResource };
}